import RestClient from './RestClient'
import RestResultType from '../consts/RestResultType'
import { showErrorMessage } from '../../../static/js/common.js'
import Cookies from 'js-cookie'
import { MessageBox } from 'element-ui'

// example
//   send(RestCfg.TENANT_NAMELIST, data, successCase, [errorCase]);
//
//   succcessCase/errorCase argument:
//     {headers: Headers, statusCode: string, body: object(depends on type)}
//
//   errorCase called when:
//     - status code != 200
//     - resultCode === "1003" (invalid token)
//     - resultCode === "9001" (system error)
//     - resultCode === "9002" (unknown error)

let tempCfg = null
let tempData = null
let tempSuccessCallback = null
let tempErrorCallback = null
let tempMsgCallback = null
let i18n = require('./I18nClient').default.getI18n
// layer の index
let index
// 今同時進行中のリクエスト数
let requestCount = 0

let send = (cfg, data, successCallback, errorCallback, messageCallback) => {
  tempCfg = JSON.parse(JSON.stringify(cfg))
  const tokenId = window.location.href.search('Mobile') < 0 ? Cookies.get('tokenId') : Cookies.get('mobile_tokenId')
  tempCfg.header['Authorization'] = 'Bearer ' + tokenId
  data.domain = document.domain
  data.lang = Cookies.get('language')
  tempData = data
  tempSuccessCallback = successCallback
  tempErrorCallback = errorCallback
  tempMsgCallback = messageCallback

  let errCallback = (errorCallback == null) ? defaultErrorCallback : errorCallback
  let callback = (response) => {
    try {
      if (isError(tempCfg, response)) {
        errCallback(response)
      } else {
        successCallback(response.body)
      }
    } finally {
      requestCount--
      if (requestCount === 0) {
        layer.close(index)
      }
    }
  }

  if (requestCount === 0) {
    index = layer.load(1, { shade: [0.1, '#fff'] })
  }
  requestCount++

  new RestClient(tempCfg).send(data).then(callback).catch(throwCallback)
}

let isError = (cfg, response) => {
  if (response.statusCode !== 200) {
    return true
  }
  if (cfg.resultType === RestResultType.JSON) {
    if (response.body.resultCode === '1007' && cfg.successOnTokenTimeout === true) {
      return false
    } else if (response.body.resultCode !== '0000') {
      return true
    }
  }
  return false
}

let messageAlert = (message, callbackFun) => {
  MessageBox({
    title: i18n().tc('ClientMessage.title'),
    confirmButtonText: i18n().tc('ClientMessage.OKbtn'),
    lockScroll: false,
    message: message,
    dangerouslyUseHTMLString: true,
    callback: callbackFun
  })
}

let messageConfirm = (message) => {
  MessageBox({
    title: i18n().tc('ClientMessage.title'),
    message: message,
    lockScroll: false,
    confirmButtonText: i18n().tc('ClientMessage.Retrybtn'),
    showCancelButton: true,
    cancelButtonText: i18n().tc('ClientMessage.Cancelbtn')
  }).then(() => {
    send(tempCfg, tempData, tempSuccessCallback, tempErrorCallback, tempMsgCallback)
  })
}

let defaultErrorCallback = (response) => {
  var errorObject = response.body.errorInfoList
  if (response.statusCode !== 200) {
    switch (response.statusCode) {
      case 404:
        messageAlert(i18n().tc('ClientMessage.page404'))
        break

      case 500:
        messageAlert(i18n().tc('ClientMessage.page500'))
        break

      default:
        messageAlert(i18n().tc('ClientMessage.Undefinederroe') + response.statusCode)
        break
    }
  } else {
    if (errorObject === null || errorObject === '') {
      switch (response.body.resultCode) {
        case '1001':
          // バリデーションチェックNG
          messageAlert(i18n().tc('ClientMessage.page1001'))
          break

        case '1002':
          // 認証NG
          messageAlert(i18n().tc('ClientMessage.page1002'))
          break

        case '1003':
          // トークン不正
          messageAlert(i18n().tc('ClientMessage.page1003'), goTop)
          break

        case '1004':
          // 排他チェックNG
          messageAlert(i18n().tc('ClientMessage.page1004'))
          break

        case '1005':
          // ファイルバリデーションチェックNG
          messageAlert(i18n().tc('ClientMessage.page1005'))
          break

        case '1006':
          // 権限不正
          messageAlert(i18n().tc('ClientMessage.page1006'))
          break

        case '1007':
          // トークンタイムアウト
          messageAlert(i18n().tc('ClientMessage.page1007'), goTop)
          break

        case '9001':
          messageAlert(i18n().tc('ClientMessage.page9001'))
          break

        case '9002':
          messageAlert(i18n().tc('ClientMessage.page9002'))
          break

        default:
          messageAlert(i18n().tc('ClientMessage.Unknownerror'))
      }
    } else {
      if (tempMsgCallback == null) {
        messageAlert(showErrorMessage(errorObject, false))
      } else {
        let { errorObject: err, switchedFlag } = tempMsgCallback(errorObject)
        messageAlert(showErrorMessage(err, switchedFlag))
      }
    }
  }
}

let throwCallback = (err) => {
  requestCount--
  if (requestCount === 0) {
    layer.close(index)
  }
  if (err.message.search(/timeout of \d+ms exceeded/) === 0) {
    messageConfirm(i18n().tc('ClientMessage.timeout'))
  } else {
    messageAlert(i18n().tc('ClientMessage.Request'))
  }
}

let goTop = () => {
  if (parent !== undefined) {
    parent.location.href = 'login'
  } else {
    location.href = 'login'
  }
}

export default {
  send: send
}



// WEBPACK FOOTER //
// ./src/scripts/services/NmsClient.js